import DocPersonal from './modifications/features/documentacion/pages/DocPersonal'
import Home from './modifications/pages/Home'

const pages = {
  home: Home,
  docpersonal: DocPersonal,
}

export default pages
